'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';
import { useTranslations } from 'next-intl';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const t = useTranslations('error');

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-grey-for-bg px-4">
      <div className="text-center">
        <h1 className="mb-4 text-9xl font-bold text-primary-red">500</h1>
        <h2 className="mb-4 text-3xl font-semibold text-primary-grey md:text-4xl">{t('internalServerError')}</h2>
        <p className="mb-8 text-lg text-primary-grey">{t('internalServerErrorDescription')}</p>
        <button
          onClick={() => reset()}
          className="inline-block rounded-lg bg-primary-red px-8 py-3 text-white transition-colors hover:bg-secondary-red"
        >
          {t('tryAgain')}
        </button>
      </div>
    </div>
  );
}
